var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"hb-indicators"},_vm._l((_vm.indicators),function(x){return _c('span',{key:x.title,class:x.color,attrs:{"title":x.title}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }